
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/si-test-series",
      function () {
        return require("private-next-pages/si-test-series/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/si-test-series"])
      });
    }
  